<template>
    <Draggable v-show="emediaModalVisible" id='drag1'>
        <div v-bind:class="{rtcVoiceContent: streamType=='语音', rtcVideoContent: streamType=='视频'}" >
            <div v-if="callerWaitVisible" class="mask">正在等待{{contact}}接受邀请</div>
            <div v-if="calleeWaitVisible" class="mask">{{contact}}请求{{streamType}}通话</div>
            <div v-if="voiceCallVisible" class="voiceCall">正在与{{contact}}通话</div>
            <video v-show="streamType == '视频'" ref='localVideo' v-bind:class="{localVideo: toggle, remoteVideo: !toggle}" autoPlay muted playsInline/>
            <video v-show="streamType == '视频'" ref='remoteVideo' v-bind:class="{localVideo: !toggle, remoteVideo: toggle}"  autoPlay playsInline/>
            <i v-show="showMute" class="el-icon-turn-off-microphone font microphone" isopen="true" ref='audio' @click="controlStream('audioControl')"></i>
            <i v-show="showAccept" class="el-icon-phone font accept" isopen="true" @click="accept"></i>
            <i v-show="showMute && streamType=='视频'" class="font camera" ref='video' isopen="true" @click="controlStream('videoControl')">
							<svg class="svg" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6929"><path d="M290.370435 380.792133C282.629994 402.20722 262.311836 417.592195 238.628964 417.592195h-1.722318C206.610232 417.592195 181.822439 392.41678 181.822439 361.646829c0-24.225342 15.364995-44.983071 36.686174-52.717518l71.861822 71.862822zM164.329522 254.75122H129.873171v513.498536h547.465366v-0.489522l54.827457 54.827458A31.870876 31.870876 0 0 1 709.307317 832.187317H97.90439c-17.682732 0-31.96878-14.286049-31.96878-31.96878V222.782439c0-17.682732 14.286049-31.96878 31.96878-31.96878h3.914178a64.321186 64.321186 0 0 0 7.329842 8.756448L164.329522 254.75122z m180.843395 0l-63.937561-63.937561H709.307317c17.682732 0 31.96878 14.286049 31.968781 31.96878v217.787317l167.836097-138.564683c21.27922-12.288 47.953171 3.096976 47.953171 27.672976v363.74478c0 24.476098-26.673951 39.861073-47.953171 27.573073L741.276098 584.429268v66.425132l-63.937561-63.937561V254.75122H345.172917zM741.276098 511.500488l151.851707 120.881951V390.618537L741.276098 511.500488zM87.54151 87.54151c12.484808-12.483809 32.726041-12.483809 45.210849 0l801.783009 801.784008c12.484808 12.483809 12.484808 32.726041 0 45.20985-12.483809 12.484808-32.726041 12.484808-45.20985 0L87.54151 132.752359c-12.483809-12.484808-12.483809-32.726041 0-45.210849z" p-id="6930"></path></svg>
						</i>
            <i v-show="showMute" class="font mute" ref="mute" @click="mute">
							<svg class="svg" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10962"><path d="M499.77 39.58a27.78 27.78 0 0 0-29.08 2.63l-291 218.21H39.78A27.76 27.76 0 0 0 12 288.2v447.59a27.76 27.76 0 0 0 27.78 27.78h139.94l291 218.21a27.58 27.58 0 0 0 16.66 5.56 27.77 27.77 0 0 0 27.78-27.78V64.43a27.79 27.79 0 0 0-15.39-24.85zM459.56 904L205.63 713.58A27.7 27.7 0 0 0 189 708H67.56V316H189a27.7 27.7 0 0 0 16.66-5.56L459.56 120zM856.84 512l147-147a27.77 27.77 0 0 0-39.28-39.28l-147 147-147-147A27.77 27.77 0 0 0 631.25 365l147 147-147 147a27.77 27.77 0 1 0 39.28 39.28l147-147 147 147a27.77 27.77 0 1 0 39.33-39.28z" p-id="10963"></path></svg>
						</i>
            <i class="el-icon-switch-button close" @click="close"></i>
            <i v-show="showMute && streamType=='视频'" class="el-icon-refresh font toggle" @click="toggleClick"></i>
        </div>
    </Draggable>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Draggable from "../draggable";
export default{
	data(){
		return {
			emediaModalVisible: false,
			showAccept: false,
			showMute: false,
			callerWaitVisible: false,
			calleeWaitVisible: false,
			voiceCallVisible: false,
			contact: "",
			streamType: "视频",
			toggle: true,
			serverStyle: {
				width: "360px",
				height: "360px"
			}
		};
	},
	watch: {
    'emediaModalVisible': {
      deep: true,
      handler: function(newV, oldV) {
		if (newV) {
			this.$emit("changeIsVideoState",true); 
		}else{
			this.$emit("changeIsVideoState",false); 
		}
      }
    }
  },
	methods: {
		...mapActions([
			"showMultiAVModal",
			"hideMultiAVModal"
		]),
		initWebRTC(){
			console.log("InitWebRTC..........");
			// if (this.$IM.call) {
			//     return
			// }
			console.log("InitWebRTC end..........");
			const me = this;

			this.$IM.call = new this.$IM.WebRTC.Call({
				connection: me.$IM.conn,

				// 自定义分辨率 采样率
				// mediaStreamConstaints: {
				//     audio: {
				//         sampleRate: 44100,
				//         sampleSize: 16
				//     },
				//     video: {
				//         width: {
				//             exact: 1280
				//         },
				//         height: {
				//             exact: 720
				//         }
				//     }
				// },

				mediaStreamConstaints: {
					audio: true,
					video: true
				},

				listener: {
					onOtherUserOpenVoice: function(from, opened){
						console.log("对方操作音频的回调", opened, " voice .", from);
					},
					onOtherUserOpenVideo: function(from, opened){
						console.log("对方操作视频的回调", opened, " voideo .", from);
					},
					onAcceptCall: function(from, options, enableVoice, enableVideo){
						console.log("接起通话", from, options, enableVoice, enableVideo);
					},
					onGotRemoteStream: function(stream, streamType){
						if(streamType == "VOICE"){
							me.$data.voiceCallVisible = true;
							me.$data.streamType = "语音";
						}
						else{
							me.$data.voiceCallVisible = false;
							me.$data.streamType = "视频";
						}
						me.$refs.remoteVideo.srcObject = stream;
						me.$data.callerWaitVisible = false;
					},
					onGotLocalStream: function(stream, streamType){
						console.log("主叫方收到被叫接受呼叫的回调", stream);
						if(streamType == "VOICE"){
							me.$data.voiceCallVisible = true;
							me.$data.streamType = "语音";
						}
						else{
							me.$data.voiceCallVisible = false;
							me.$data.streamType = "视频";
						}
						me.$refs.localVideo.srcObject = stream;
						me.$data.calleeWaitVisible = false;
					},
					onRinging: function(caller, streamType){
						console.log("被叫方收到呼叫回调", caller);
						if(streamType != "VOICE"){
							me.$data.calleeWaitVisible = true;
							me.$data.streamType = "视频";
						}
						else{
							me.$data.calleeWaitVisible = true;
							me.$data.streamType = "语音";
						}
						me.$data.contact = caller;
						me.$data.emediaModalVisible = true;
						me.$data.showAccept = true;
						me.$data.showMute = false;
					},
					onTermCall: function(reason){
						// "ok"      -> 'HANGUP'     "success" -> 'HANGUP'   "timeout"          -> 'NORESPONSE'
						// "decline" -> 'REJECT'     "busy"    -> 'BUSY'     "failed-transport" -> 'FAIL'
						// TODO reason undefine if reason is busy
						console.log("onTermCall", reason);
						if(reason && (reason == "busy" || reason == "BUSY")){
							me.$message.error("对方正忙，请稍候再拨");
							this.callerWaitVisible = false
						}
						if(reason && (reason == "timeout" || reason == "noresponse")){
							me.$message.error("对方无响应，请稍候再拨");
							this.callerWaitVisible = false
						}
						if(reason && (reason == "decline" || reason == "reject")){
							me.$message.error("对方已拒绝");
							this.callerWaitVisible = false
						}
						if(reason && (reason == "failed-transport" || reason == "fail")){
							me.$message.error("拨打失败，请稍候再拨");
							this.callerWaitVisible = false
						}
						if(reason && (reason == "ok" || reason == "success" || reason == "hangup")){
							me.$message.success("对方已挂断 ");
							this.callerWaitVisible = false
						}

						me.$IM.call.caller = "";
						me.$IM.call.callee = "";
						me.closeEmediaModal();
						me.$data.emediaModalVisible = false;
						me.$data.showAccept = false;
						me.$data.showMute = false;
						me.$data.callerWaitVisible = false;
						me.$data.calleeWaitVisible = false;
						me.$data.voiceCallVisible = false;
						me.$data.contact = "";
						me.$refs.audio.isopen = true;
						me.$refs.video.isopen = true;
						me.$refs.remoteVideo.muted = false;
						me.$refs.video.style.color = "#2c3e50";
						me.$refs.audio.style.color = "#2c3e50";
						me.$refs.mute.style.color = "#2c3e50";
					},
					onIceConnectionStateChange: function(iceState){
						console.log("onIceConnectionStateChange");

						if(iceState == "disconnected"){
							if(!me.rtcTimeoutID){
								// console.warn("Warn. disconnect. notify offline");

								me.rtcTimeoutID = setTimeout(function(){
									if(!(me.$IM.call.pattern && me.$IM.call.pattern.hangup)){
										me.$message.success("对方不在线");
										me.closeEmediaModal();
									}
								}, 10000);
							}
						}
						else if(iceState == "connected"){
							if(me.rtcTimeoutID){
								clearTimeout(me.rtcTimeoutID);
								me.rtcTimeoutID = null;
							}
						}
					},
					// 通话断网监听
					onNetWorkDisconnect(endType) { // endType: local || remote, 哪一端断网
						console.log('1v1 onNetWorkDisconnect 通话断网监听', endType);
					},
					onError: function(e){
						console.log('1v1 onError 通话报错', e);
						var close = false;
						var closeButton = document.getElementById("webrtc_close");
						if(e && e.message){
							switch(e.message){
							case "CALLLING_EACH_OTHER_AT_THE_SAME_TIME":
								e.message = "Target is calling. Please try again later.";
								close = true;
								break;
							case "TARGET_OFFLINE":
								e.message = "Target is offline.";
								break;
							case 'callee is not online!':
								e.message = "对方不在线无法进行音视频通话";
							break;
							default:
								break;
							}
							if(close){
								closeButton && closeButton.click();
							}
						}
						me.$message.error(e && e.message ? e.message : "An error occured when calling webrtc");
						me.closeEmediaModal();
					},
					onInvite: function(from, rtcOption){
						const { confrId, password, gid } = rtcOption;
						const { appkey, xmppURL } = me.$IM.config;
						// const { avModal, multiAV } = me.props
						let host = xmppURL.split(".");
						host = "@" + host[1] + "." + host[2];
						from = from.replace(appkey + "_", "");
						from = from.replace(host, "");
						let callback = (confr) => {
							me.$confirm(from + "邀请您进入多人会议", "提示", {
								confirmButtonText: "确认",
								cancelButtonText: "拒绝",
								type: "info"
							}).then(() => {
								me.showMultiAVModal();
								setTimeout(() => {
									const tkt = confr.ticket;
									me.$IM.EMService.joinConferenceWithTicket(confr.confrId, tkt, "user ext field").then(function(){
										me.$IM.EMService.publish({ audio: true, video: true }, "user ext field")["catch"](function(e){
											console.error(e);
										});
									})["catch"](function(e){
										console.error(e);
									});
								}, 0);

							})["catch"](action => {
							});
						};
						me.$IM.EMedia.mgr.getConferenceTkt(confrId, password).then(function(confr){
							callback(confr);
						});
					}
				}
			});
		},
		close: function(){
			this.closeEmediaModal();
			try{
				this.$IM.call.endCall();
			}
			catch(e){
				console.log("endCall error1:", e);
			}
		},
		toggleClick(){
			this.$data.toggle = !this.$data.toggle;
		},
		mute(){
			let muted = this.$refs.remoteVideo.muted;
			if(muted){
				this.$refs.mute.style.color = "#2c3e50";
				this.$refs.remoteVideo.muted = false;
			}
			else{
				this.$refs.mute.style.color = "#4eb1f4";
				this.$refs.remoteVideo.muted = true;
			}
		},
		controlStream(type){
			let controlType;
			let to = this.$IM.call.callee.split("@")[0].split("_")[1];
			if(type === "audioControl"){
				controlType = this.$refs.audio.isopen ? 0 : 1;
				this.$refs.audio.style.color = this.$refs.audio.isopen ? "#2c3e50" : "#4eb1f4";
				this.$refs.audio.isopen = !this.$refs.audio.isopen;
			}
			else{
				controlType = this.$refs.video.isopen ? 3 : 2;
				this.$refs.video.style.color = this.$refs.video.isopen ? "#2c3e50" : "#4eb1f4";
				this.$refs.video.isopen = !this.$refs.video.isopen;
			}
			this.$IM.call.controlStream(controlType, to);
		},
		showEmediaModal(){
			this.$data.emediaModalVisible = true;
		},
		closeEmediaModal(){
			this.$data.emediaModalVisible = false;
		},
		accept(){
			this.$IM.call.acceptCall();
		},
		loadedmetadataLocalHandler(){
			this.$data.showMute = true;
			this.$data.showAccept = false;
			// this.$data.serverStyle = {
			//     width: 360 + "px",
			//     height: 360 + "px"
			// }
		},
		showCallerWait(to){
			this.$data.callerWaitVisible = true;
			this.$data.contact = to;
		}
	},
	components: {
		Draggable
	},
	mounted(){
		if(this.$IM.config.isWebRTC && this.$IM.WebRTC){
			this.initWebRTC();
			// this.channel = new RTCChannel(this.refs.rtcWrapper, this.props.collapsed)
		}
		var video = this.$refs.localVideo;
		video.addEventListener("loadedmetadata", this.loadedmetadataLocalHandler);
	},
};
</script>
<style scoped lang="scss">
@import "./index.scss";
.rtcVoiceContent{
    min-width: 350px;
    min-height: 90px;
    border-radius: 5px;
}
.rtcVideoContent{
    min-width: 350px;
    min-height: 350px;
    margin: auto;
}
.mask{
    height: 100%;
    width: 100%;
    position: absolute;
    cursor: default;
    left: 0;
    background: #ccc;
    z-index: 3;
    border-radius: 5px;
}
.voiceCall{
    height: 150px;
    background: #e2e2e2;
    z-index: 3;
    border-radius: 5px;
    border-radius: 5px;
    line-height: 50px;
    color: rgba(0,0,0,0.65);
}
.svg{
	display: block;
	margin: 0 auto;
}
</style>
